/**
 * Created by evgenijsenkevic on 13/2/25
 */

const FriendPixelsPlanner = function () {
    this.onCreatePixel = function () {};
    this.friendPixels = [];
};

FriendPixelsPlanner.prototype.destructor = function () {
    this.friendPixels = undefined;

    this.clearFriendPixels();
};

FriendPixelsPlanner.prototype.planFriendPixels = function () {
    if (this.timeout || cleverapps.config.editorMode || cleverapps.config.adminMode) {
        return;
    }

    this.timeout = cleverapps.timeouts.setTimeout(() => this.createFriendPixels(), 5000);
};

FriendPixelsPlanner.prototype.clearFriendPixels = function () {
    if (this.timeout) {
        cleverapps.timeouts.clearTimeout(this.timeout);
        this.timeout = undefined;
    }
};

FriendPixelsPlanner.prototype.createFriendPixels = function () {
    this.clearFriendPixels();

    let requests = levels.friendRequests.getNotProcessedIdsByType(
        levels.FriendRequest.TYPE_SENT_UNIT
    );

    requests = requests.filter((request) => !this.friendPixels.some((pixel) => pixel.friendRequest.id === request.id));

    const maxPixelsAmount = Math.min(requests.length, FriendPixelsPlanner.MAX_FRIEND_PIXELS - this.friendPixels.length);

    let pixels = [];
    for (let i = 0; i < maxPixelsAmount; i++) {
        pixels.push(new Pixel({
            type: PixelsSwarm.FRIEND,
            friendRequest: requests[i],
            order: i,
            amountPixels: requests.length,
            onDiePixel: this.onDiePixel.bind(this)
        }));
    }

    pixels = pixels.sort((p1, p2) => p2.order - p1.order);

    pixels.forEach((pixel) => {
        this.friendPixels.push(pixel);
        this.onCreatePixel(pixel);
    });
};

FriendPixelsPlanner.prototype.onDiePixel = function (diePixel) {
    if (this.friendPixels) {
        this.friendPixels = this.friendPixels.filter((pixel) => diePixel.friendRequest.id !== pixel.friendRequest.id);
    }

    this.planFriendPixels();
};

FriendPixelsPlanner.prototype.createTutorialPixel = function () {
    const request = levels.FriendRequest.createFriendRequest({
        id: "tutorialpixel",
        from: "tutorial",
        type: levels.FriendRequest.TYPE_SENT_UNIT,
        fake: true
    });

    const point = Map2d.currentMap.scroller.scrollCell;

    const pixel = new Pixel({
        type: PixelsSwarm.FRIEND,
        friendRequest: request,
        order: 0,
        spawnPoint: {
            x: point.x + FriendPixelsPlanner.TUTORIAL_PIXEL_SPAWN_OFFSET,
            y: point.y - FriendPixelsPlanner.TUTORIAL_PIXEL_SPAWN_OFFSET
        },
        amountPixels: 1,
        onDiePixel: this.onDiePixel.bind(this)
    });

    this.friendPixels.push(pixel);
    this.onCreatePixel(pixel);
    return pixel;
};

FriendPixelsPlanner.MAX_FRIEND_PIXELS = 5;
FriendPixelsPlanner.TUTORIAL_PIXEL_SPAWN_OFFSET = 5;